module.exports = __webpack_public_path__ + "img/map.5c77bcff.svg";